export default {
  nav: {
    home: 'Startseite',
    spreadsheet: 'Spreadsheet',
    guides: 'Guides',
    shopping_guide: 'Einkaufs-Guide',
    shipping: 'Versand',
    qc: 'QC',
    reviews: 'Bewertungen',
    categories: 'Kategorien',
    language: 'Sprache',
  },
  hero: {
    title: 'AllChinaBuy Spreadsheet – Produkte, Verkäufer, QC & Kauf-Guides',
    subtitle: 'Ihr AllChinaBuy Spreadsheet & Kauf-Ressourcen Hub',
    description: 'Entdecken Sie nützliche AllChinaBuy Spreadsheet-Ressourcen, Produktlisten, Verkäuferinformationen, QC-Guides, Versandtipps und praktische Kaufratschläge — organisiert in einem übersichtlichen Hub.',
    cta_primary: 'AllChinaBuy Spreadsheet Erkunden',
    cta_secondary: 'Kauf-Guides Durchsuchen',
    trust: 'Unabhängige Ressourcen • Aktualisierter Inhalt • Praktische Kaufinformationen',
  },
  categories: {
    title: 'Beliebte AllChinaBuy Spreadsheet Kategorien',
    subtitle: 'Durchsuchen Sie Produktkategorien und finden Sie das, was Sie brauchen, schneller',
    shoes: 'Schuhe',
    hoodies: 'Hoodies/Pullover',
    tshirts: 'T-Shirts',
    jackets: 'Jacken',
    pants: 'Hosen/Shorts',
    headwear: 'Kopfbedeckungen',
    sets: 'Sets',
    underwear: 'Unterwäsche',
    jersey: 'Trikots',
    accessories: 'Accessoires',
    bags: 'Taschen',
    belts: 'Gürtel',
    perfumes: 'Parfums',
    other: 'Sonstiges',
  },
  cta: {
    title: 'Bereit zum Einkaufen?',
    description: 'Besuchen Sie unsere Hauptwebsite für die vollständige AllChinaBuy Spreadsheet-Erfahrung und beginnen Sie noch heute mit der Produktsuche.',
    button_main: 'AllChinaBuy Spreadsheet',
    button_buy: 'Jetzt Kaufen',
  },
  articles: {
    title: 'Neueste AllChinaBuy Spreadsheet Guides',
    subtitle: 'Lernen Sie mit unseren umfassenden Ressourcen intelligenter einzukaufen',
    read_more: 'Mehr Lesen',
    article_1_title: 'AllChinaBuy Spreadsheet Komplett-Guide 2026',
    article_1_desc: 'Alles, was Sie über die Verwendung des AllChinaBuy Spreadsheets wissen müssen, um Produkte zu finden, Verkäufer zu vergleichen und fundierte Kaufentscheidungen zu treffen.',
    article_2_title: 'So Lesen Sie AllChinaBuy QC-Fotos',
    article_2_desc: 'Eine Schritt-für-Schritt-Anleitung zum Verstehen von Qualitätskontrollfotos und zur Überprüfung von Produktdetails vor dem Kauf.',
    article_3_title: 'AllChinaBuy Versandmethoden im Vergleich',
    article_3_desc: 'Vergleichen Sie Versandoptionen, Kosten, Lieferzeiten und Tracking-Funktionen, um die beste Methode für Ihre Bedürfnisse zu wählen.',
    article_4_title: 'Ist AllChinaBuy Sicher? Ein Kompletter Sicherheits-Guide',
    article_4_desc: 'Lernen Sie Sicherheitsmaßnahmen, Zahlungsschutz, Verkäuferverifizierung und wie Sie gängige Betrugsversuche vermeiden.',
    article_5_title: 'AllChinaBuy Test 2026',
    article_5_desc: 'Ein detaillierter Blick auf die Bestellabläufe, den Lagerservice, die Qualitätskontrolle und den Versand bei AllChinaBuy.',
    article_6_title: 'AllChinaBuy Versandkosten Guide',
    article_6_desc: 'Verstehen Sie Versandpreise, Methoden, versteckte Kosten und praktische Strategien zur Reduzierung Ihrer Ausgaben.',
    article_7_title: 'AllChinaBuy Lager Guide',
    article_7_desc: 'So funktioniert das AllChinaBuy Lager, kostenlose Lagerzeiten, QC-Fotos und Konsolidierung erklärt.',
    article_8_title: 'AllChinaBuy Gutschein & Rabatt Guide',
    article_8_desc: 'Erfahren Sie, wie AllChinaBuy Aktionen funktionieren, woher echte Rabatte kommen und wie Sie Fake-Gutscheine vermeiden.',
    article_9_title: 'Ist AllChinaBuy Seriös?',
    article_9_desc: 'Was AllChinaBuy zu einer legitimen Plattform macht, wo die echten Risiken liegen und wie Sie sich schützen.',
    article_10_title: 'AllChinaBuy Verkäufer Guide',
    article_10_desc: 'So bewerten Sie Verkäufer, erkennen Warnsignale und bauen eine vertrauenswürdige Liste auf.',
    article_11_title: 'So Finden Sie Produkte auf AllChinaBuy',
    article_11_desc: 'Effektive Suchstrategien, Filter und Verifizierungstipps, um Qualitätsprodukte schneller zu finden.',
    article_12_title: 'AllChinaBuy Kauf Guide',
    article_12_desc: 'Eine vollständige Anleitung zum AllChinaBuy Kaufprozess von Ihrer ersten Bestellung bis zur Lieferung.',
    article_13_title: 'AllChinaBuy Versandrechner Guide',
    article_13_desc: 'So schätzen Sie Versandkosten genau ein und nutzen die Ergebnisse für bessere Entscheidungen.',
    article_14_title: 'Häufige AllChinaBuy Fehler',
    article_14_desc: 'Vermeiden Sie die häufigsten Fehler neuer Käufer und kaufen Sie von Anfang an mit Vertrauen.',
  },
  features: {
    title: 'Warum Unsere AllChinaBuy Spreadsheet Ressourcen Nutzen?',
    feature_1_title: 'Organisierte Produktlisten',
    feature_1_desc: 'Finden Sie Produkte in allen Kategorien mit strukturierten Tabellen, die Ihnen Stunden der Suche ersparen.',
    feature_2_title: 'Verkäuferinformationen',
    feature_2_desc: 'Greifen Sie auf detaillierte Verkäuferdaten, Bewertungen und Produktpaletten zu, um selbstbewusste Kaufentscheidungen zu treffen.',
    feature_3_title: 'QC & Qualitäts-Guides',
    feature_3_desc: 'Verstehen Sie Qualitätskontrollprozesse und lernen Sie, was Sie vor Bestellbestätigung überprüfen sollten.',
    feature_4_title: 'Versand-Ressourcen',
    feature_4_desc: 'Vergleichen Sie Versandmethoden, Kosten und Lieferzeiten, um Ihre Kaufstrategie zu optimieren.',
  },
  footer: {
    title: 'AllChinaBuy Spreadsheet Hub',
    description: 'Ihre unabhängige Ressource für AllChinaBuy Spreadsheet-Guides, Produktlisten und Kaufinformationen.',
    links: 'Schnelle Links',
    resources: 'Ressourcen',
    legal: 'Rechtliches',
    privacy: 'Datenschutz',
    terms: 'Nutzungsbedingungen',
    disclaimer: 'Haftungsausschluss',
    contact: 'Kontakt',
    copyright: '© 2026 AllChinaBuy Spreadsheet Hub. Alle Rechte vorbehalten.',
    disclaimer_text: 'Diese Website ist eine unabhängige Informationsressource. Informationen können sich ändern und sollten vor Kaufentscheidungen unabhängig verifiziert werden.',
  },
  not_found: {
    title: 'Seite Nicht Gefunden',
    description: 'Die gesuchte Seite existiert nicht. Kehren Sie zur Startseite zurück, um AllChinaBuy Spreadsheet-Ressourcen zu erkunden.',
    back_home: 'Zurück zur Startseite',
  },
  seo: {
    meta_title: 'AllChinaBuy Spreadsheet – Produkte, Verkäufer, QC & Kauf-Guides',
    meta_description: 'Entdecken Sie das neueste AllChinaBuy Spreadsheet, Produktressourcen, Verkäufer-Guides, QC-Tipps, Versandinformationen und Kauf-Guides. Finden Sie Produkte schneller und shoppen Sie intelligenter.',
  },
  dropdown: {
    select_category: 'Kategorie Wählen',
    go: 'Los',
  },
  products: {
    title: 'Empfohlene Produkte',
    subtitle: 'Entdecken Sie ausgewählte Produkte aus unserem AllChinaBuy Arbeitsblatt — klicken Sie auf ein Element, um Details anzusehen und auf unserer Hauptwebsite zu kaufen.',
    view_all: 'Alle ansehen',
  },
  faq: {
    title: 'Häufig Gestellte Fragen',
    q1: 'Was ist das AllChinaBuy Spreadsheet?',
    a1: 'Das AllChinaBuy Spreadsheet ist eine organisierte Ressource, die Käufern hilft, Produkte, Verkäufer und Kaufinformationen in mehreren Kategorien zu finden. Es spart Zeit, indem es nützliche Links und Produktdetails an einem Ort sammelt.',
    q2: 'Ist AllChinaBuy sicher zu verwenden?',
    a2: 'AllChinaBuy ist eine legitime Plattform. Wie bei jedem Online-Marktplatz sollten Käufer jedoch Verkäufer verifizieren, QC-Fotos prüfen und sichere Zahlungsmethoden verwenden. Unsere Guides helfen Ihnen beim sicheren Einkaufen.',
    q3: 'Wie finde ich die besten Produkte?',
    a3: 'Nutzen Sie unsere Kategorie-Guides und Spreadsheet-Ressourcen, um Produkte über Verkäufer hinweg zu vergleichen. Lesen Sie QC-Guides und prüfen Sie Bewertungen, bevor Sie Käufe tätigen.',
    q4: 'Welche Versandmethoden sind verfügbar?',
    a4: 'AllChinaBuy bietet verschiedene Versandoptionen. Sehen Sie sich unseren Versandvergleichs-Guide an, um die beste Methode basierend auf Ihrem Standort, Budget und Lieferbedürfnissen zu finden.',
  },
};